import React, { FC } from "react";

interface Props {
  className?: string
}

const PanelFooter: FC<Props> = (props) => {
  return (
    <div id='panel-footer' className={props.className ? props.className : ''}>
      {props.children}
    </div>
  )
}

export default PanelFooter
